module.exports = __webpack_public_path__ + "img/Shudog Services LLC.6609b37b.png";